export default [
    {
        path: '/documents',
        name: 'documents',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Documents.vue')
    }
]